export default __webpack_public_path__ + "static/media/unread-mark.91fefc4d.svg";